import axios from 'axios';
import { VueCookieNext } from 'vue-cookie-next';

const instance = axios.create({
  baseURL: '/api',
});
instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
instance.defaults.headers.common['responseType'] = 'json';
instance.defaults.headers.get['Content-Type'] = 'application/json';
instance.interceptors.request.use(
  (config) => {
    config.headers['Authorization'] =
      VueCookieNext.getCookie('accessToken') || '';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    if (error.response.status === 419 && !originalRequest._retry) {
      originalRequest._retry = true;
      await instance.get('/csrf-cookie');

      return instance(originalRequest);
    }
    return Promise.reject(error);
  }
);

export default instance;
